import type { VoidFunctionComponent } from 'react';
import { usePlansContext } from './PlansContext';
import Flex from '../../../generic/Flex';
import styles from './styles.module.less';
import Button from '../../../generic/Button';

const PlansHeaderComponent: VoidFunctionComponent = () => {
  const {
    viewInterval,
    setViewInterval,
  } = usePlansContext();
  return (
    <Flex
      direction="row"
      align="center"
      gap={20}
      className={styles.plansController}
    >
      <span className={styles.plansControllerTitle}>
        Change Plan
      </span>
      <span>
        Billing
      </span>
      <div className={styles.toggleButtonsContainer}>
        <Button
          onClick={() => setViewInterval('year')}
          type={viewInterval === 'year' ? 'primary' : 'outline'}
          size="large"
        >
          Yearly
        </Button>
        <Button
          onClick={() => setViewInterval('month')}
          type={viewInterval === 'month' ? 'primary' : 'outline'}
          size="large"
        >
          Monthly
        </Button>
      </div>
    </Flex>
  );
};

export default PlansHeaderComponent;
